import { ReactNode } from "react";

import ViewHeaderNavigation from "components/ViewHeader/Navigation";
import Box from "ds/components/Box";
import Tab from "ds/components/Tab";
import TooltipInfo from "ds/components/TooltipInfo";
import PageInfoHeaderWrapper from "ds/components/PageInfoHeader/Wrapper";
import PageInfoHeaderTitle from "ds/components/PageInfoHeader/Title";
import PageInfoHeaderCaption from "ds/components/PageInfoHeader/Caption";
import PageInfoHeaderActions from "ds/components/PageInfoHeader/Actions";

type UsageLayoutHeaderNewProps = {
  title: string;
  tooltip?: ReactNode;
  caption?: ReactNode;
  children?: ReactNode;
};

const UsageLayoutHeaderNew = ({ title, tooltip, caption, children }: UsageLayoutHeaderNewProps) => (
  <PageInfoHeaderWrapper align="start">
    <Box direction="column">
      <Box direction="column" gap="small">
        <Box direction="row" align="center" gap="small">
          <PageInfoHeaderTitle title={title} />
          {tooltip && <TooltipInfo widthMode="maxWidthSm">{tooltip}</TooltipInfo>}
        </Box>
        {caption && <PageInfoHeaderCaption caption={caption} />}
      </Box>

      <ViewHeaderNavigation>
        <Tab to="../workers" label="Workers" />
        <Tab to="../runs" label="Runs" />
      </ViewHeaderNavigation>
    </Box>

    <PageInfoHeaderActions>{children}</PageInfoHeaderActions>
  </PageInfoHeaderWrapper>
);

export default UsageLayoutHeaderNew;
